/**
 * Os tipos das três dimensões de permissão.
 *
 * A matriz do protótipo (#v-acessos, tabela `tb-rbac`) não responde
 * "pode ou não pode" — ela responde três perguntas diferentes, e cada
 * uma se aplica num ponto distinto do ciclo da requisição:
 *
 *   Ação      "Criar e editar"              → guard antes do caso de uso
 *   Escopo    "Alunos das próprias turmas"  → predicado na consulta
 *   Projeção  "Lançar, sem ver folha"       → colunas do SELECT
 *
 * Cada CÉLULA da matriz guarda um NÍVEL, não um booleano. O nível
 * traduz para as três dimensões. É esse desenho que permite expressar
 * "Sem margem e custos" — impossível numa grade de checkboxes.
 *
 * Ver: Arena_backend/Docs/plano/03-access-tres-dimensoes.md
 *      Arena_backend/Docs/plano/19-permissoes-auditoria.md
 */
export const PERFIS = ['dono', 'gestao', 'professor', 'aluno'];
export const RECURSOS = [
    'dashboard',
    'alunos',
    'perfis',
    'turmas',
    'planos',
    'cobrancas',
    'agenda',
    'bi',
    'financeiro',
    'folha',
    'estoque',
    'comanda',
];
/** Dimensão 1 · o que o perfil pode invocar. */
export const ACOES = [
    'ler',
    'criar',
    'editar',
    'excluir',
    'cancelar',
    'anonimizar',
    'registrar_chamada',
    'registrar_pagamento',
    'aplicar',
    'abrir',
    'lancar',
    'fechar',
    'solicitar',
];
/**
 * Dimensão 2 · quais linhas. O nome é um contrato: cada módulo registra
 * a estratégia concreta no registry de `access/`, e a camada de acesso
 * nunca precisa conhecer `turmas` ou `faturas`.
 */
export const ESCOPOS = [
    'todos',
    'nenhum',
    'proprias_turmas',
    'propria_grade',
    'propria_matricula',
    'proprio_registro',
    'propria_comanda',
    'sem_sensivel',
    'horarios_livres',
];
/**
 * Dimensão 3 · quais colunas. O nome corresponde a uma chave do mapa
 * `<modulo>.projection.ts`. Coluna que o perfil não pode ver NÃO SAI
 * do banco — filtrar na serialização deixa o dado passar por memória
 * e por log.
 */
export const PROJECOES = [
    'completo',
    'sem_margem_custos',
    'sem_folha',
    'sem_saude',
    'basico',
];
//# sourceMappingURL=tipos.js.map